module.exports = __webpack_public_path__ + "img/launchpad-texture-moonbeam.a62c5ff0.jpg";